var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-total-edit-content-wrapper",
    {
      attrs: { value: _vm.currentTab },
      on: {
        input: function ($event) {
          return _vm.$emit("update:currentTab", $event)
        },
      },
    },
    [
      _c(
        "w-sortable",
        {
          attrs: {
            tag: "w-list",
            items: _vm.value.Filters,
            "target-class": "handle",
            "disable-x": "",
            "keep-in-y": "",
          },
        },
        _vm._l(_vm.value.Filters, function (filter, i) {
          return _c("app-total-edit-filter-item", {
            key: filter.key,
            attrs: {
              filter: filter,
              "is-editing": _vm.selectedFilter == filter,
              model: _vm.model,
              browse: _vm.browse,
            },
            on: {
              edit: function ($event) {
                return _vm.editFilter(i)
              },
              remove: function ($event) {
                return _vm.removeFilter(i)
              },
            },
          })
        }),
        1
      ),
      _c(
        "w-list-item",
        {
          on: {
            click: function ($event) {
              return _vm.addFilter()
            },
          },
        },
        [
          _c("w-list-item-icon", [_c("w-fa", { attrs: { icon: "plus" } })], 1),
          _c("w-list-item-text", [_vm._v(_vm._s(_vm.$ct("add-filter")))]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }